export const JobStatusConstant = {
  STATUS_QUEUED: 'queued',
  STATUS_EXECUTING: 'executing',
  STATUS_FINISHED: 'finished',
  STATUS_FAILED: 'failed',
  STATUS_RETRYING: 'retrying',
};

export const ImportJobTypeConstant = {
  SALES_ORDER: 'Import Sales Order Job',
  BULK_SAVE_SHIPPING_LABELS: 'Bulk Save Shipping Labels Job',
  GET_API2CART_PRODUCTS_JOB: 'Get Api2Cart Products Job',
  GET_ECART_API_PRODUCTS_JOB: 'Get Ecart Api Products Job',
  GET_QUICKBOOKS_PRODUCTS_JOB: 'Get Quickbooks Products Job',
  GET_SHOPIFY_PRODUCTS_JOB: 'Get Shopify Products Job',
  GET_TRACKSTAR_PRODUCTS_JOB: 'Get Trackstar Products Job',
  GET_ORDER_UPDATES_FROM_SELECT_ALL_JOB: 'Get Order Updates From Select All Job',
  UPDATE_ORDER_STATUS_FROM_SELECT_ALL_JOB:
    'Update Order Status From Select All Job',
  UPDATE_TAG_FROM_SELECT_ALL_JOB: 'Update Tags From Select All Job',
  SHIP_ORDERS_FROM_SELECT_ALL_JOB: 'Ship Orders From Select All Job',
  IMPORT_V1_MASTER_VARIANT_DETAILS_JOB: 'Import V1 Master Variant Details Job',
  IMPORT_CLIENT_SHIPPING_ADDRESSES_JOB: 'Import Client Shipping Addresses Job',
};

export const OmsJobTypeConstant = {
  GET_OMS_ORDERS_JOB: 'Get OMS Orders Job',
  SYNC_TRACKSTAR_ORDERS_JOB: 'Sync Trackstar Orders Job',
  SYNC_SHIPSTATION_ORDERS_JOB: 'Sync ShipStation Orders Job',
  SYNC_SHOPIFY_ORDERS_JOB: 'Sync Shopify Orders Job',
};

export enum EJobType {
  COST_LAYERS_REPAIR = 'cost_layers_repair',
}
